export const LEFT_NAV_EXTENDED_ENABLED_CONTENT_CLASS = 'content-left-nav-extended-enabled';

export const LEFT_NAV_COLLAPSED_ENABLED_CONTENT_CLASS = 'content-left-nav-collapsed-enabled';
